import { render } from "./GlobalSearch.vue?vue&type=template&id=8ea39a36"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/GlobalSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ea39a36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ea39a36', __exports__)) {
    console.log('reload')
    api.reload('8ea39a36', __exports__)
  }
  
  module.hot.accept("./GlobalSearch.vue?vue&type=template&id=8ea39a36", () => {
    console.log('re-render')
    api.rerender('8ea39a36', render)
  })

}


export default __exports__